import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col, InputGroup, Form, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaPlus, FaEdit, FaTrash, FaSortUp, FaSortDown, FaSort, FaSearch, FaUserPlus, FaUserMinus } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import * as api from '~/Services/Service';
import { selectStylesSm } from '~/Styles/reactSelectStyles';
import AuthStorage from '~/Utils/AuthStorage';
import ModalDepartamento from './ModalDepartamento';

const Departamento = () => {
  const [departamentos, setDepartamentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [departamentoSelecionado, setDepartamentoSelecionado] = useState(null);
  const [confirmacao, setConfirmacao] = useState({ show: false, item: null });
  const [filtro, setFiltro] = useState('');
  const [ordenacao, setOrdenacao] = useState({ campo: 'codigo', direcao: 'asc' });

  // Colaboradores modal
  const [showColabModal, setShowColabModal] = useState(false);
  const [colabDepto, setColabDepto] = useState(null);
  const [colaboradores, setColaboradores] = useState([]);
  const [loadingColab, setLoadingColab] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [confirmacaoTroca, setConfirmacaoTroca] = useState({ show: false, departamentoAtual: '', codigoUsuario: null });
  const [confirmacaoRemover, setConfirmacaoRemover] = useState({ show: false, item: null });
  const [buscaColab, setBuscaColab] = useState('');

  useEffect(() => {
    carregarDepartamentos();
  }, []);

  const carregarDepartamentos = async () => {
    setLoading(true);
    try {
      const resp = await api.buscarDepartamentos();
      setDepartamentos(resp || []);
    } catch (e) {
      toast.error('Erro ao carregar departamentos.');
    } finally {
      setLoading(false);
    }
  };

  const handleOrdenacao = (campo) => {
    setOrdenacao((prev) => {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  const iconeOrdenacao = (campo) => {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  const linkStyle = {
    cursor: 'pointer',
    color: '#0747a6',
    textDecoration: 'underline',
    fontWeight: 'bold',
  };

  const thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  const handleNovo = () => {
    setDepartamentoSelecionado(null);
    setShowModal(true);
  };

  const handleEditar = (item) => {
    setDepartamentoSelecionado(item);
    setShowModal(true);
  };

  // === Colaboradores ===
  const handleAbrirColaboradores = async (item) => {
    setColabDepto(item);
    setColaboradores([]);
    setUsuarioSelecionado(null);
    setBuscaColab('');
    setShowColabModal(true);
    setLoadingColab(true);
    try {
      const [colabs, usus] = await Promise.all([
        api.buscarColaboradoresDepartamento(item.codigo),
        api.buscarUsuarioOptions('ativos'),
      ]);
      setColaboradores(colabs || []);
      setUsuarios(usus || []);
    } catch (e) {
      toast.error('Erro ao carregar colaboradores.');
    } finally {
      setLoadingColab(false);
    }
  };

  const recarregarColaboradores = async () => {
    if (!colabDepto) return;
    try {
      const colabs = await api.buscarColaboradoresDepartamento(colabDepto.codigo);
      setColaboradores(colabs || []);
    } catch (e) {
      // silencioso
    }
  };

  const opsUsuarios = usuarios.map((u) => {
    const nome = u.nome_completo ? u.nome_completo : (u.apelido ? u.apelido : String(u.codigo_usuario));
    return {
      value: u.codigo_usuario,
      label: u.codigo_usuario + ' - ' + nome,
      apelido: u.apelido || '',
    };
  });

  const filtrarUsuario = (option, inputValue) => {
    if (!inputValue) return true;
    const termo = inputValue.toLowerCase();
    const codigo = String(option.data.value);
    const label = (option.data.label || '').toLowerCase();
    const apelido = (option.data.apelido || '').toLowerCase();
    return codigo.indexOf(termo) >= 0 || label.indexOf(termo) >= 0 || apelido.indexOf(termo) >= 0;
  };

  const handleAdicionarColaborador = async () => {
    if (!usuarioSelecionado) {
      toast.error('Selecione um colaborador.');
      return;
    }
    try {
      const resp = await api.adicionarColaboradorDepartamento({
        codigo_departamento: colabDepto.codigo,
        codigo_usuario: usuarioSelecionado.value,
        confirmar: false,
      });
      if (resp && resp.confirmacao_necessaria) {
        setConfirmacaoTroca({
          show: true,
          departamentoAtual: resp.departamento_atual || '',
          codigoUsuario: usuarioSelecionado.value,
        });
        return;
      }
      toast.success('Colaborador adicionado com sucesso.');
      setUsuarioSelecionado(null);
      recarregarColaboradores();
      carregarDepartamentos();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao adicionar colaborador.');
    }
  };

  const handleConfirmarTroca = async (confirmado) => {
    if (!confirmado) {
      setConfirmacaoTroca({ show: false, departamentoAtual: '', codigoUsuario: null });
      return;
    }
    const codigoUsuario = confirmacaoTroca.codigoUsuario;
    setConfirmacaoTroca({ show: false, departamentoAtual: '', codigoUsuario: null });
    try {
      await api.adicionarColaboradorDepartamento({
        codigo_departamento: colabDepto.codigo,
        codigo_usuario: codigoUsuario,
        confirmar: true,
      });
      toast.success('Colaborador transferido com sucesso.');
      setUsuarioSelecionado(null);
      recarregarColaboradores();
      carregarDepartamentos();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao transferir colaborador.');
    }
  };

  const handleRemoverColaborador = (item) => {
    setConfirmacaoRemover({ show: true, item: item });
  };

  const handleConfirmarRemover = async (confirmado) => {
    if (!confirmado) {
      setConfirmacaoRemover({ show: false, item: null });
      return;
    }
    const item = confirmacaoRemover.item;
    setConfirmacaoRemover({ show: false, item: null });
    try {
      await api.removerColaboradorDepartamento({ codigo_usuario: item.codigo_usuario });
      toast.success('Colaborador removido com sucesso.');
      recarregarColaboradores();
      carregarDepartamentos();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao remover colaborador.');
    }
  };

  // === Exclusão Departamento ===
  const handleExcluir = (item) => {
    setConfirmacao({ show: true, item: item });
  };

  const handleConfirmarExclusao = async (confirmado) => {
    if (!confirmado) {
      setConfirmacao({ show: false, item: null });
      return;
    }
    const item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await api.excluirDepartamento({ codigo: item.codigo });
      toast.success('Departamento excluído com sucesso.');
      carregarDepartamentos();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao excluir departamento.');
    }
  };

  const handleSalvar = () => {
    setShowModal(false);
    carregarDepartamentos();
  };

  const departamentosFiltrados = departamentos.filter((item) => {
    if (!filtro) return true;
    const termo = filtro.toLowerCase();
    return (
      String(item.codigo).indexOf(termo) >= 0 ||
      (item.descricao || '').toLowerCase().indexOf(termo) >= 0 ||
      (item.nome_responsavel || '').toLowerCase().indexOf(termo) >= 0
    );
  });

  const departamentosOrdenados = departamentosFiltrados.slice().sort((a, b) => {
    const campo = ordenacao.campo;
    const dir = ordenacao.direcao === 'asc' ? 1 : -1;
    let valA = a[campo];
    let valB = b[campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    if (typeof valA === 'string') {
      return dir * valA.toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (valA - valB);
  });

  const itemExclusao = confirmacao.item;

  // Filtrar colaboradores no modal
  const colaboradoresFiltrados = colaboradores.filter((item) => {
    if (!buscaColab) return true;
    const termo = buscaColab.toLowerCase();
    return (
      String(item.codigo_usuario).indexOf(termo) >= 0 ||
      (item.nome || '').toLowerCase().indexOf(termo) >= 0 ||
      (item.nome_usuario || '').toLowerCase().indexOf(termo) >= 0 ||
      (item.email || '').toLowerCase().indexOf(termo) >= 0
    );
  });

  if (loading) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .depto-desktop { display: block; }\
        .depto-mobile  { display: none; }\
        .depto-desktop thead th { position: sticky; top: 0; background: #fff; z-index: 1; }\
        @media (max-width: 768px) {\
          .depto-desktop { display: none !important; }\
          .depto-mobile  { display: block; }\
          .depto-filtro-row { flex-direction: column; }\
          .depto-filtro-row .text-right { text-align: right !important; margin-top: 8px; }\
        }\
      '}</style>

      <Header title="Departamentos" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center depto-filtro-row">
            <Col md={4}>
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text><FaSearch /></InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  placeholder="Filtrar por código, descrição ou responsável..."
                  value={filtro}
                  onChange={(e) => { setFiltro(e.target.value); }}
                />
              </InputGroup>
            </Col>
            <Col className="text-right">
              <Button
                size="sm"
                variant="primary"
                onClick={handleNovo}
                disabled={!(AuthStorage && AuthStorage.temCaracteristica(261))}
              >
                <FaPlus className="mr-1" /> Novo Departamento
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Departamentos
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({departamentosOrdenados.length} {departamentosOrdenados.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {departamentosOrdenados.length === 0 ? (
            <p className="text-muted text-center my-4">Nenhum departamento cadastrado.</p>
          ) : (
            <>
              {/* Desktop */}
              <div className="depto-desktop" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th
                        style={Object.assign({ width: '80px' }, thSortStyle)}
                        onClick={() => { handleOrdenacao('codigo'); }}
                      >
                        Código{iconeOrdenacao('codigo')}
                      </th>
                      <th
                        style={thSortStyle}
                        onClick={() => { handleOrdenacao('descricao'); }}
                      >
                        Descrição{iconeOrdenacao('descricao')}
                      </th>
                      <th
                        style={thSortStyle}
                        onClick={() => { handleOrdenacao('nome_responsavel'); }}
                      >
                        Responsável{iconeOrdenacao('nome_responsavel')}
                      </th>
                      <th
                        style={Object.assign({ width: '110px' }, thSortStyle)}
                        onClick={() => { handleOrdenacao('qtd_funcionarios'); }}
                      >
                        Colaboradores{iconeOrdenacao('qtd_funcionarios')}
                      </th>
                      <th
                        style={thSortStyle}
                        onClick={() => { handleOrdenacao('nome_categoria'); }}
                      >
                        Categoria{iconeOrdenacao('nome_categoria')}
                      </th>
                      <th
                        style={Object.assign({ width: '80px' }, thSortStyle)}
                        onClick={() => { handleOrdenacao('status'); }}
                      >
                        Status{iconeOrdenacao('status')}
                      </th>
                      <th style={{ width: '90px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {departamentosOrdenados.map((item) => {
                      return (
                        <tr key={item.codigo}>
                          <td>{item.codigo}</td>
                          <td>{item.descricao}</td>
                          <td>{item.nome_responsavel || '—'}</td>
                          <td className="text-center">
                            <span style={linkStyle} onClick={() => { handleAbrirColaboradores(item); }}>
                              {item.qtd_funcionarios || 0}
                            </span>
                          </td>
                          <td>{item.nome_categoria || '—'}</td>
                          <td>
                            <span style={{
                              color: item.status === 'A' ? '#28a745' : '#dc3545',
                              fontWeight: 'bold',
                            }}>
                              {item.status === 'A' ? 'Ativo' : 'Inativo'}
                            </span>
                          </td>
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              title="Editar"
                              className="mr-1"
                              onClick={() => { handleEditar(item); }}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Excluir"
                              onClick={() => { handleExcluir(item); }}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="depto-mobile p-2">
                {departamentosOrdenados.map((item) => {
                  return (
                    <Card key={item.codigo} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>{item.descricao}</strong>
                            <br />
                            <small className="text-muted">Código: {item.codigo}</small>
                          </div>
                          <span style={{
                            color: item.status === 'A' ? '#28a745' : '#dc3545',
                            fontWeight: 'bold',
                            fontSize: '0.8rem',
                          }}>
                            {item.status === 'A' ? 'Ativo' : 'Inativo'}
                          </span>
                        </div>
                        <div style={{ fontSize: '0.85rem' }} className="mb-1">
                          Responsável: <strong>{item.nome_responsavel || '—'}</strong>
                        </div>
                        <div style={{ fontSize: '0.85rem' }} className="mb-1">
                          Categoria: <strong>{item.nome_categoria || '—'}</strong>
                        </div>
                        <div style={{ fontSize: '0.85rem' }} className="mb-2">
                          Colaboradores:{' '}
                          <span style={linkStyle} onClick={() => { handleAbrirColaboradores(item); }}>
                            {item.qtd_funcionarios || 0}
                          </span>
                        </div>
                        <div className="d-flex justify-content-end">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="mr-1"
                            onClick={() => { handleEditar(item); }}
                          >
                            <FaEdit className="mr-1" /> Editar
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => { handleExcluir(item); }}
                          >
                            <FaTrash className="mr-1" /> Excluir
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      <ModalConfirmacao
        show={confirmacao.show}
        title="Confirmar Exclusão"
        message={
          itemExclusao
            ? 'Deseja excluir o departamento "' + (itemExclusao.descricao || '') + '" (Código ' + itemExclusao.codigo + ')?'
            : ''
        }
        onClose={handleConfirmarExclusao}
      />

      <ModalDepartamento
        show={showModal}
        onHide={() => { setShowModal(false); }}
        departamento={departamentoSelecionado}
        onSalvar={handleSalvar}
      />

      {/* Modal de Colaboradores com Add/Remove */}
      {showColabModal && (
        <Modal show onHide={() => { setShowColabModal(false); }} centered size="lg">
          <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
            <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
              Colaboradores — {colabDepto ? colabDepto.descricao : ''}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Adicionar colaborador */}
            <Row className="align-items-end mb-3">
              <Col md={8}>
                <Form.Label style={{ fontSize: '0.85rem', fontWeight: 'bold', marginBottom: 2 }}>
                  Adicionar Colaborador
                </Form.Label>
                <Select
                  options={opsUsuarios}
                  value={usuarioSelecionado}
                  onChange={setUsuarioSelecionado}
                  filterOption={filtrarUsuario}
                  placeholder="Selecione um colaborador..."
                  isClearable
                  styles={selectStylesSm}
                />
              </Col>
              <Col md={4}>
                <Button size="sm" variant="success" onClick={handleAdicionarColaborador}>
                  <FaUserPlus className="mr-1" /> Adicionar
                </Button>
              </Col>
            </Row>

            <hr className="my-2" />

            {/* Busca na lista */}
            {colaboradores.length > 0 && (
              <InputGroup size="sm" className="mb-2">
                <InputGroup.Prepend>
                  <InputGroup.Text><FaSearch /></InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  placeholder="Buscar colaborador..."
                  value={buscaColab}
                  onChange={(e) => { setBuscaColab(e.target.value); }}
                />
              </InputGroup>
            )}

            {/* Lista de colaboradores */}
            {loadingColab ? (
              <p className="text-center text-muted my-3">Carregando...</p>
            ) : colaboradoresFiltrados.length === 0 ? (
              <p className="text-center text-muted my-3">
                {colaboradores.length === 0 ? 'Nenhum colaborador vinculado.' : 'Nenhum resultado para a busca.'}
              </p>
            ) : (
              <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: '60px' }}>#</th>
                      <th>Nome</th>
                      <th>E-mail</th>
                      <th style={{ width: '60px', textAlign: 'center' }}>Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {colaboradoresFiltrados.map((u) => {
                      return (
                        <tr key={u.codigo_usuario}>
                          <td>{u.codigo_usuario}</td>
                          <td>{u.nome || u.nome_usuario || '—'}</td>
                          <td>{u.email || '—'}</td>
                          <td className="text-center">
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Remover"
                              onClick={() => { handleRemoverColaborador(u); }}
                            >
                              <FaUserMinus />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}

            <div className="text-muted text-right mt-1" style={{ fontSize: '0.8rem' }}>
              {colaboradores.length} colaborador{colaboradores.length !== 1 ? 'es' : ''} vinculado{colaboradores.length !== 1 ? 's' : ''}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" size="sm" onClick={() => { setShowColabModal(false); }}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Confirmação de troca de departamento */}
      <ModalConfirmacao
        show={confirmacaoTroca.show}
        title="Confirmar Troca de Departamento"
        message={
          'Prestador já está vinculado ao Departamento "' + confirmacaoTroca.departamentoAtual + '". Confirma troca?'
        }
        onClose={handleConfirmarTroca}
      />

      {/* Confirmação de remoção de colaborador */}
      <ModalConfirmacao
        show={confirmacaoRemover.show}
        title="Remover Colaborador"
        message={
          confirmacaoRemover.item
            ? 'Deseja remover o colaborador "' + (confirmacaoRemover.item.nome || confirmacaoRemover.item.nome_usuario || '') + '" do departamento?'
            : ''
        }
        onClose={handleConfirmarRemover}
      />
    </Container>
  );
};

export default Departamento;
